export interface IResponse<TData> {
    isSuccess: boolean;
    message: string;
    data?: TData;
    statusCode?: number;
}

export class Result<TData>  {
    constructor(res: IResponse<TData> = { isSuccess: false, message: "", statusCode: 200 }) {
        this.isSuccess = res.isSuccess;
        this.message = res.message;
        this.isAuthorized = res.statusCode != 401;
        this.statusCode = res.statusCode;
        if (!!res.data) {
            this.data = res.data;
        }
    }

    isSuccess: boolean = false;
    isAuthorized: boolean = false;
    message: string = '';
    data?: TData;
    statusCode?: number = 200;

    setCompleted(): void {
        this.isSuccess = true;
    }

    setFailed(message: string): void {
        this.isSuccess = false;
        this.message = message;
    }

    setData(data: TData): void {
        this.setCompleted();
        this.data = data;
    }

    Ok(): boolean {
        return this.isSuccess;
    }

    hasData(): boolean {
        return this.Ok() && this.data != null;
    }
}

export class ResultArray<TData> extends Result<Array<TData>> {
    hasData(): boolean {
        return this.Ok() && this.data != null && this.data.IsNotNullOrEmpty();
    }
}

export interface IPhoto {
    id: string;
    photoUrl: string;
}

export interface IGalleryItem {
    title: string;
    description: string;
    image: string;
}

export class PageResult<TData> extends Result<Array<TData>> {
    constructor(
        res: {
            hasNextPage: boolean,
            pageSize?: number,
            pageIndex?: number,
            isSuccess: boolean,
            message: string,
            data?: TData[] | undefined
        }) {
        const rep: IResponse<TData[]> = {
            isSuccess: res.isSuccess,
            message: res.message,
            data: res.data
        }
        super(rep);
        this.hasNextPage = res.hasNextPage;
        this.pageSize = res.pageSize ?? 20;
        this.pageIndex = res.pageSize ?? 1
    }

    hasNextPage: boolean;
    pageSize: number;
    pageIndex: number;

    toResult() : Result<Array<TData>> {
        return new  Result<Array<TData>>({
            isSuccess:  this.isSuccess,
            message:  this.message,
            data:  this.data,
            statusCode:  this.statusCode
        });
    }
}

export interface PromiseResult<TResult> extends Promise<Result<TResult>> {
}